import React from 'react';
import {Box, Typography} from '@mui/material';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';

interface EndOfListingProps {
  message?: string;
  showDivider?: boolean;
  sx?: object;
}

const EndOfListing: React.FC<EndOfListingProps> = ({
  message = "You've reached the end of the listings",
  showDivider = true,
  sx = {},
}) => {
  const theme = useWrappedTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      sx={{
        py: {xxs: 3, md: 4},
        px: {xxs: 2, md: 3},
        ...sx,
      }}
    >
      {showDivider && (
        <Box
          sx={{
            width: '200px',
            height: '1px',
            backgroundColor: theme.palette.divider,
            mb: 2,
          }}
        />
      )}

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          fontSize: {xxs: '14px', md: '16px'},
          fontWeight: 400,
          maxWidth: '400px',
          lineHeight: 1.5,
        }}
      >
        {message}
      </Typography>

      <Typography
        variant="caption"
        color="text.disabled"
        sx={{
          fontSize: {xxs: '12px', md: '14px'},
          mt: 0.5,
          fontWeight: 300,
        }}
      >
        Check back later for new opportunities
      </Typography>
    </Box>
  );
};

export default EndOfListing;
